export default __webpack_public_path__ + "static/media/flag-button-active.2fc90ca1.png";